// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ecommerce__nav-bar',
    // #endregion
    // #region Data
    data: () => ({
        leftMenu: [],
        rightMenu: [],
        currentMenu: null,
        hasSwitch: false,
        _currentItem: null
    }),
    // #endregion
    // #region Watcher
    watch: {
        'mainMenuEntries': function (value) {
            this.initailize();
        },
        '$route.path': function (value) {
            //Item
            this._currentItem = null;
            //Switch
            this.updateSwitch(value);
        }
    },
    // #endregion
    // #region Constructor
    created() {
        this.initailize();
    },
    // #endregion
    // #region Computes
    computed: {
        _self() {
            return this;
        },
        mainMenuEntriesLeft() {
            return this.leftMenu;
        },
        mainMenuEntriesRight() {
            return this.rightMenu;
        },
        mainMenuEntries() {
            return this.$appHost.store.getter("navigation/getMenu", "MAIN");
        },
    },
    // #endregion
    // #region Methods
    methods: {
        // #region Boostrao
        initailize() {
            // #region Load
            this.leftMenu = this.$appHost.store.getter('navigation/getMenu', 'MAIN').filter((e) => e.alignment == 0);
            this.rightMenu = this.$appHost.store.getter('navigation/getMenu', 'MAIN').filter((e) => e.alignment == 1);
            this.hasSwitch = this.leftMenu && this.leftMenu.some(e => e.actionType === "SWITCH");
            // #endregion
            // #region Switch
            this.updateSwitch(this.$route.path);
            // #endregion               
        },
        // #endregion
        // #region Tools
        updateSwitch(url) {
            // #region Check
            if (!this.hasSwitch) {
                return;
            }
            // #endregion
            // #region Url
            // Vars
            var tPath = url?.toLowerCase();
            {
                if (!tPath.endsWith("/")) {
                    tPath = tPath + '/';
                }
            }
            // #endregion
            // #region Find
            var tSwitch = this.leftMenu.find(e => e.actionType === "SWITCH");
            {
                if (tSwitch && tSwitch.children.length > 0) {
                    // #region Route
                    if (tPath != "/") {
                        for (let tItem of tSwitch.children) {
                            let tUrl = this.getUrl(tItem);
                            {
                                if (!tUrl) {
                                    continue;
                                }
                            }
                            if (this.$route.path?.toLowerCase().startsWith(tUrl.toLowerCase())) {
                                this.currentMenu = tItem;
                                break;
                            }
                        }
                    }
                    // #endregion
                    // #region Store
                    if (!this.currentMenu) {
                        let tStore = JSON.parse(window.localStorage.getItem('288a_ecommerce_store') ?? '{}');
                        {
                            if (tStore.catalogMenuID) {
                                this.currentMenu = tSwitch.children.find(e => e.menuID === tStore.catalogMenuID);
                            }
                        }
                    }
                    // #endregion
                    // #region Fallback
                    if (!this.currentMenu || !tSwitch.children.some(e => e.menuID === this.currentMenu?.menuID)) {
                        this.currentMenu = tSwitch.children[0];
                    }
                    // #endregion
                }
            }
            // #endregion
        },
        switchTo(item) {
            // #region Set
            this.currentMenu = item;
            // #endregion
            // #region Store
            {
                //Update
                let tStore = JSON.parse(window.localStorage.getItem('288a_ecommerce_store') ?? '{}');
                {
                    tStore.catalogMenuID = item?.menuID;
                }
                //Set
                window.localStorage.setItem('288a_ecommerce_store', JSON.stringify(tStore));
            }
            // #endregion
            // #region Link
            let tLink = this.getUrl(item);
            {
                if (tLink) {
                    this.$router.push(tLink);
                }
            }
            // #endregion                
        },
        getUrl(item) {
            if (!item) {
                return null;
            }
            let tLink = item.actionCommand?.toLowerCase();
            {
                if (tLink) {
                    // #region App
                    //App => app://
                    if (tLink.startsWith("app://")) {
                        var tlink2 = item.actionCommand.substr(6);
                        //Optimize
                        if (!tlink2.startsWith('/')) {
                            tlink2 = '/' + tlink2;
                        }
                        return tlink2;
                    }
                    // #endregion
                    // #region To
                    //App => to://
                    else if (tLink.startsWith("to://")) {
                        var tlink2 = item.actionCommand.substr(5);
                        //Optimize
                        if (!tlink2.startsWith('/')) {
                            tlink2 = '/' + tlink2;
                        }
                        return tlink2;
                    }
                    // #endregion
                }
            }
            return null;
        },
        // #endregion
    }
    // #endregion        
});
// #endregion
